




















import { Store } from 'vuex';
import { Component, Vue } from 'vue-property-decorator';
import { AppState } from '@/store/index';
import { RouteName } from '../router';
import { ExerciseMetric, exerciseMetricToString } from '../models/exercise.model';
import { EXERCISE_DELETE_ACTION } from '../store/exercise.store';

@Component
export default class ExerciseList extends Vue {
  $store!: Store<AppState>;
  RouteName = RouteName;

  get title() {
    return this.$route.name;
  }

  get exercises() {
    return this.$store.state.exercise.exercises;
  }

  metric(metric: ExerciseMetric) {
    return exerciseMetricToString(metric);
  }

  addExercise() {
    this.$router.push({ name: RouteName.ExerciseAdd });
  }

  deleteExercise(id: string) {
    this.$store.dispatch(EXERCISE_DELETE_ACTION, {
      id,
      database: this.$database,
    });
  }
}
